<template>
  <a-drawer width='80%' :label-col='4' :wrapper-col='14' :visible='open' @close='cancel'>
    <a-divider orientation='left'>
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref='form' :model='form' :rules='rules'>
      <!-- APP类型 -->
      <a-form-model-item :label="$t('appVersion.appType')" prop='appType'>
        <a-select :placeholder="$t('appVersion.selectAppType')" v-model="form.appType">
          <a-select-option value="0">{{ $t('appVersion.android') }}</a-select-option>
          <a-select-option value="1">{{ $t('appVersion.ios') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- 版本号名称 -->
      <a-form-model-item :label="$t('appVersion.versionName')" prop='versionName'>
        <a-input v-model='form.versionName' :placeholder="$t('appVersion.inputVersionName')" :maxLength='15'/>
      </a-form-model-item>
      <!-- 版本号 -->
      <a-form-model-item :label="$t('appVersion.versionCode')" prop='versionCode'>
        <a-input v-model='form.versionCode' :placeholder="$t('appVersion.inputVersionCode')" :maxLength='15'/>
      </a-form-model-item>
      <!-- 更新包大小 -->
      <a-form-model-item :label="$t('appVersion.packageSize')" prop='upHeSize'>
        <a-input-number v-model='form.upHeSize' style="width: 100%;" :placeholder="$t('appVersion.inputPackageSize')" :min='0.01' :maxLength='10' :max='9999'/>
      </a-form-model-item>
      <!-- 更新地址类型 -->
      <a-form-model-item :label="$t('appVersion.updateUrlType')" prop='upUrlType'>
        <a-select :placeholder="$t('appVersion.selectUpdateUrlType')" v-model="form.upUrlType">
          <a-select-option value="0">{{ $t('appVersion.internal') }}</a-select-option>
          <a-select-option value="1">{{ $t('appVersion.market') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- 其它(应用市场)应用地址（当更新地址类型为"其它(应用市场)"时显示） -->
      <a-form-model-item :label="$t('appVersion.inputMarketUrl')" prop='upUrl'
                         v-if="form.upUrlType == 1">
        <a-input v-model='form.upUrl' :placeholder="$t('appVersion.inputMarketUrl')" />
      </a-form-model-item>
      <!-- 更新类型 -->
      <a-form-model-item :label="$t('appVersion.updateType')" prop='upType'>
        <a-select :placeholder="$t('appVersion.selectUpdateType')" v-model="form.upType">
          <a-select-option value="0">{{ $t('appVersion.hotUpdate') }}</a-select-option>
          <a-select-option value="1">{{ $t('appVersion.fullUpdate') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- 强制升级否 -->
      <a-form-model-item :label="$t('appVersion.forceUpdateStatus')" prop='compulsoryUp'>
        <a-select :placeholder="$t('appVersion.selectForceUpdate')" v-model="form.compulsoryUp">
          <a-select-option value="0">{{ $t('appVersion.force') }}</a-select-option>
          <a-select-option value="1">{{ $t('appVersion.canSkip') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- 下载地址 -->
      <a-form-model-item :label="$t('appVersion.downloadUrl')" prop='downloadUrl'>
        <a-input v-model='form.downloadUrl' :placeholder="$t('appVersion.inputDownloadUrl')" :maxLength='500'/>
      </a-form-model-item>
      <!-- 更新说明 -->
      <a-form-model-item :label="$t('appVersion.updateNotes')" prop='upNotes'>
        <a-input v-model='form.upNotes' :placeholder="$t('appVersion.inputUpdateNotes')" :maxLength='30'/>
      </a-form-model-item>
      <!-- 底部操作按钮 -->
      <div class='bottom-control'>
        <a-space>
          <a-button type='primary' :loading='submitLoading' @click='submitForm'>
            {{ $t('common.save') }}
          </a-button>
          <a-button type='dashed' @click='cancel'>
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVersionInfo, addVersionInfo, updateVersionInfo } from '@/api/app/versionInfo'

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      // 提交加载状态
      submitLoading: false,
      // 表单标题
      formTitle: '',
      // 表单类型：1-新增，2-修改
      formType: 1,
      // 抽屉显示状态
      open: false,
      // 表单数据
      form: {
        id: null,
        appType: "0",
        upNotes: null,
        upHeSize: null,
        upUrlType: undefined,
        upUrl: null,
        versionName: null,
        versionCode: null,
        upType: null,
        compulsoryUp: null,
        downloadUrl: null,
        createTime: null,
        remark: null
      },
    }
  },
  computed: {
    rules() {
      return {
        appType: [
          {
            required: true,
            message: this.$t('appVersion.appTypeRequired'),
            trigger: 'change'
          }
        ],
        upUrlType: [
          {
            required: true,
            message: this.$t('appVersion.updateUrlTypeRequired'),
            trigger: 'change'
          }
        ],
        versionCode: [
          {
            required: true,
            message: this.$t('appVersion.versionCodeRequired')
          }
        ],
        upType: [
          {
            required: true,
            message: this.$t('appVersion.updateTypeRequired'),
            trigger: 'change'
          }
        ],
        compulsoryUp: [
          {
            required: true,
            message: this.$t('appVersion.forceUpdateRequired')
          }
        ],
        downloadUrl: [
          {
            required: true,
            message: this.$t('appVersion.downloadUrlRequired')
          }
        ]
      }
    }
  },
  methods: {
    /**
     * 取消操作
     */
    cancel() {
      this.open = false
      this.reset()
    },
    /**
     * 表单重置
     */
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        appType: "0",
        upNotes: null,
        upHeSize: null,
        upUrlType: null,
        upUrl: null,
        versionName: null,
        versionCode: null,
        upType: null,
        compulsoryUp: null,
        downloadUrl: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    /**
     * 新增按钮操作
     */
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /**
     * 修改按钮操作
     * @param {Object} row - 行数据
     * @param {Number|String} ids - ID（备用参数）
     */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVersionInfo({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /**
     * 提交表单
     */
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            // 修改
            updateVersionInfo(this.form).then(response => {
              this.$message.success(this.$t('common.updateSuccess'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            // 新增
            addVersionInfo(this.form).then(response => {
              this.$message.success(this.$t('common.addSuccess'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
